import React from "react";
import { Routes, Route } from "react-router-dom";
import Masterwebpage from "./layouts/admin/Masterwebpage";
import Masterauthwebpage from "./layouts/authAdmin/Masterauthwebpage";
import axios from "axios";

import VerifyFaqPrintout from "./components/admin/childComponents/verify/VerifyFaqPrintout";
import VerifyCatPrintout from "./components/admin/childComponents/verify/VerifyCatPrintout";

import TestScript from "./components/admin/childComponents/verify/TestScript";
import InteractiveMap from "./map/InteractiveMap";

import * as $ from "jquery";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

window.jQuery = $;
window.$ = $;

let defaultsBend = BACKEND_URL;

axios.defaults.baseURL = defaultsBend;
axios.defaults.withXSRFToken = true;
axios.defaults.withCredentials = true;
axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

axios.interceptors.request.use(function (config) {
  const token = localStorage.getItem("auth_token");
  config.headers.Authorization = token ? `Bearer ${token}` : "";
  return config;
});
function App() {
  // Encrypt Decrypt Data //
  // const encrypt = (encrypDycrypData, type) => {
  //   let result;
  //   if (type === "Encrypt") {
  //     result = window.btoa(encrypDycrypData);
  //   } else if (type === "Decrypt") {
  //     result = window.atob(encrypDycrypData);
  //   }
  //   return result;
  // };

  //   let value01, value02;
  //   value01 = encrypt("fileNumber[eq]=12+fileType[eq]=44", "Encrypt"); //Encrypt, Decrypt
  //   value02 = encrypt(value01, "Decrypt"); //Encrypt, Decrypt
  //   console.log("Encrypt:", value01, "  Decrypt:", value02);
  // End Encrypt Decrypt Data //

  return (
    <Routes>
      {/* used to run testscript */}
      <Route path="/testscript" element={<TestScript />} />
      <Route path="/interactivemap" element={<InteractiveMap />} />

      {/* Admin Login Section */}
      <Route path="/" element={<Masterauthwebpage name="Login" />} />
      <Route path="/login" element={<Masterauthwebpage name="Login" />} />
      <Route path="/logout" element={<Masterauthwebpage name="Login" />} />
      <Route
        path="/register01"
        element={<Masterauthwebpage name="Register01" />}
      />
      <Route
        path="/register02"
        element={<Masterauthwebpage name="Register02" />}
      />
      <Route
        path="/register02/:otp"
        element={<Masterauthwebpage name="Register02b" />}
      />
      <Route
        path="/forgotpassword01"
        element={<Masterauthwebpage name="Forgotpassword01" />}
      />
      <Route
        path="/forgotpassword02"
        element={<Masterauthwebpage name="Forgotpassword02" />}
      />
      <Route
        path="/forgotpassword02/:otp"
        element={<Masterauthwebpage name="Forgotpassword02b" />}
      />
      {/* End of Admin Login Section */}

      <Route path="/VerifyFaqPrintout" element={<VerifyFaqPrintout />} />
      <Route path="/VerifyCatPrintout" element={<VerifyCatPrintout />} />
      

      {/* Admin Authoried Access */}

      {/* Added Components */}

      <Route path="/1gps" element={<Masterwebpage name="GPS" />} />
      <Route path="/1crop" element={<Masterwebpage name="Crop" />} />
      <Route path="/1print" element={<Masterwebpage name="PrintDoc" />} />
      <Route path="/1pdf" element={<Masterwebpage name="Pdf" />} />
      <Route path="/1qrcodes" element={<Masterwebpage name="QrCodes" />} />
      <Route path="/1qrscanner" element={<Masterwebpage name="QrScanner" />} />
      <Route path="/1camera" element={<Masterwebpage name="Camera" />} />

      {/* End off Added Components */}

      <Route
        path="/admin/dashboard"
        element={<Masterwebpage name="Dashboard" />}
      />
      <Route path="/admin/users" element={<Masterwebpage name="Users" />} />
      <Route path="/admin/faq" element={<Masterwebpage name="Faq" />} />
      <Route path="/admin/cat" element={<Masterwebpage name="Cat" />} />
      <Route path="/admin/pag" element={<Masterwebpage name="Pag" />} />

      <Route path="/admin/gal" element={<Masterwebpage name="Gal" />} />
      <Route path="/admin/hslide" element={<Masterwebpage name="HSlide" />} />
      <Route path="/admin/mslide" element={<Masterwebpage name="MSlide" />} />
      <Route path="/admin/pos" element={<Masterwebpage name="Pos" />} />
      <Route path="/admin/inbox" element={<Masterwebpage name="Inbox" />} />
      <Route path="/admin/:id" element={<Masterwebpage name="TargetRead" />} />
      <Route path="/admin/" element={<Masterwebpage name="Read" />} />
      {/* <Route path="/admin/composemail" element={<Masterwebpage name="ComposeMail" />} /> */}

      {/* End of Admin Authoried Access */}
      <Route path="/*" element={<Masterwebpage name="Page404" />} />
    </Routes>
  );
}

export default App;
